export default "__VITE_ASSET__lKuKoQq0__"